import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { FloatLabel } from "primereact/floatlabel";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import AdminMenu from "../../AdminMenu";
import { addFranchiseRate, addFranchiseStoreMap, getFranchiseCalculationMode, getFranchiseRateList, updateFranchiseRate, updateFranchiseStoreMap } from "../../../services/FranchiseModal/Franchise";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { getAppService } from "../../../services/BrandAppServices";
import { MultiSelect } from "primereact/multiselect";


const FranchisesRateCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item, franchise } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);

  const [storeStatus, setStoreStatus] = useState(false);
  const [codeError, setCodeError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [rateError, setRateError] = useState("");
  const [rateModeInError, setRateModeInError] = useState("");
  const [calculationModeError, setCalculationModeError] = useState("");
  const [calculationModeServiceError, setCalculationModeServiceError] =
    useState("");
  const [serviceRateErrors, setServiceRateErrors] = useState({});

  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");
  const [rate, setRate] = useState("");
  const [rateModeIn, setRateModeIn] = useState("");
  const [calculationMode, setCalculationMode] = useState("");
  const [rateCalculationMode, setRateCalculationMode] = useState([]);
  const [appServicesList, setAppServicesList] = useState([]);
  const [appServiceValue, setAppServiceValue] = useState("");

  const [serviceRates, setServiceRates] = useState({});
  const [franchiseRateData, setFranchiseRateData] = useState([]);

  const fetchFranchiseList = () => {
    getFranchiseRateList(brandId, franchise.id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setFranchiseRateData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const handleAppServiceChange = (selectedItems) => {
    setAppServiceValue(selectedItems);

    const newRates = {};
    selectedItems.forEach((service) => {
      if (!serviceRates[service]) {
        newRates[service] = ""; // default to empty rate
      }
    });

    setServiceRates((prev) => ({
      ...prev,
      ...newRates,
    }));
  };

  const fetchFranchise = () => {
    getFranchiseCalculationMode(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setRateCalculationMode(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getAppService()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const NewRes = Res.map((item) => ({
            name: item.name,
            value: item.name,
          }));
          setAppServicesList(NewRes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchFranchise();
    fetchFranchiseList();
  }, []);

  // useEffect(() => {
  //   if (item) {
  //     const entries = item?.calculationService?.split(", ")?.map((pair) => {
  //       const [key, value] = pair
  //         ?.split(":")
  //         ?.map((s) => s.trim()?.replace(/'/g, ""));
  //       return [key, value];
  //     });

  //     let obj = {}

  //     if(entries) {
  //        obj = Object.fromEntries(entries);
  //     }
  //     setCode(item.code);
  //     setDescription(item.description);
  //     setRate(item.rate);
  //     setRateModeIn(item.rateModeIn);
  //     setStoreStatus(item.status);
  //     setCalculationMode(item.calculationMode);
  //     // setAppServiceValue(item?.calculationService?.match(/\b\w+(?=:)/g));
  //     // setAppServiceValue(item.calculationService.match(/([\w\s]+)(?=:)/g));
  //     setAppServiceValue(item?.calculationService?.match(/([\w\s]+)(?=:)/g)?.map(service => service.trim()))
  //     setServiceRates(obj);
  //   }
  // }, [item]);

  useEffect(() => {
    if (item) {
      const entries = item?.calculationService
        ?.split(", ")
        ?.map((pair) => {
          const [key, value] = pair
            ?.split(":")
            ?.map((s) => s.trim()?.replace(/'/g, ""));
          return [key, value];
        })
        // Filter out entries where value is '0'
        .filter(([key, value]) => value !== "0");

      const obj = entries ? Object.fromEntries(entries) : {};

      setCode(item.code);
      setDescription(item.description);
      setRate(item.rate);
      setRateModeIn(item.rateModeIn);
      setStoreStatus(item.status);
      setCalculationMode(item.calculationMode);

      setAppServiceValue(
        item?.calculationService
          ?.match(/([\w\s]+)(?=:)/g)
          ?.map((service) => service.trim())
          // Filter out services with value '0'
          ?.filter((service) => obj[service] !== undefined)
      );

      setServiceRates(obj);
    }
  }, [item]);

  const [statusError, setStatusError] = useState(false);

  const handleRateModeInChange = (selectedItem) => {
    setRateModeIn(selectedItem);
  };

  const handleCalculationModeChange = (selectedItem) => {
    const isDuplicate = franchiseRateData.some(
      (rate) => rate.calculationMode === selectedItem && rate.status === true
    );

    if (isDuplicate) {
      setIsButtonPressed(true);
      setCalculationModeError(
        `An entry with calculation mode '${selectedItem}' already exists.`
      );
      return;
    } else {
      setCalculationModeError("");
      setIsButtonPressed(false);
    }

    setCalculationMode(selectedItem);
  };

  // const handleAppServiceChange = (selectedItem) => {
  //   setAppServiceValue(selectedItem)
  // }

  const rateModeInList = [
    {
      name: "AMOUNT",
      value: "AMOUNT",
    },
    {
      name: "PERCENTAGE",
      value: "PERCENTAGE",
    },
  ];

  const StatusList = [
    {
      name: "ACTIVE",
      value: true,
    },
    {
      name: "INACTIVE",
      value: false,
    },
  ];

  const selectedTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const optionTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <div>{option.name}</div>
      </div>
    );
  };

  const handleStatusChange = (selectedItem) => {
    setStoreStatus(selectedItem);
  };

  const handleSubmit = () => {
    // Reset all previous errors

    setStatusError("");

    let isValid = true;

    // Check for duplicate calculationMode only on create
    if (!item && calculationMode) {
      const duplicate = franchiseRateData.some(
        (rate) =>
          rate.calculationMode === calculationMode && rate.status === true // only check for active entries
      );
      if (duplicate) {
        setCalculationModeError(
          `An entry with calculation mode '${calculationMode}' already exists.`
        );
        isValid = false;
      }
    }

    // Validate other fields (as you already have)
    if (!code) {
      setCodeError("Code is Required");
      isValid = false;
    }
    if (!description) {
      setDescriptionError("Description is Required");
      isValid = false;
    }
    if (calculationMode !== "SERVICE" && !rate) {
      setRateError("Rate is Required");
      isValid = false;
    }
    if (rateModeIn === null) {
      setRateModeInError("Rate Mode In is Required");
      isValid = false;
    }
    if (storeStatus === null) {
      setStatusError("Status is Required");
      isValid = false;
    }
    if (calculationMode === null) {
      setCalculationModeError("Calculation Mode is Required");
      calculationModeServiceError("App Service is Required");
      isValid = false;
    }

    // if (calculationMode === "SERVICE") {
    //   const newServiceRateErrors = {};
    //   appServiceValue.forEach((service) => {
    //     if (!serviceRates[service] || serviceRates[service].trim() === "") {
    //       newServiceRateErrors[service] = "Rate is required";
    //       isValid = false;
    //     }
    //   });
    //   setServiceRateErrors(newServiceRateErrors);
    // }

    if (calculationMode === "SERVICE") {
      const newServiceRateErrors = {};
      appServiceValue.forEach((service) => {
        const rate = serviceRates[service];
        if (
          rate === undefined ||
          rate === null ||
          rate.toString().trim() === "" ||
          rate.toString().trim() === "0"
        ) {
          newServiceRateErrors[service] = "Rate is required";
          isValid = false;
        }
      });
      setServiceRateErrors(newServiceRateErrors);
    }


    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        const data = {
          code: code,
          description: description,
          rate: calculationMode === "SERVICE" ? 0 : rate,
          rateModeIn: rateModeIn,
          calculationMode: calculationMode,
        };

        const UpdateData = {
          id: item?.id,
          brandFranchise: {
            id: franchise.id,
          },
          code: code,
          description: description,
          rate: calculationMode === "SERVICE" ? 0 : rate,
          rateModeIn: rateModeIn,
          status: storeStatus,
          calculationMode: calculationMode,
        };

        // Convert object to desired string format
        const formattedString = Object.entries(serviceRates)
          .map(([key, value]) => `${key}: '${value}'`)
          .join(", ");

        if (calculationMode === "SERVICE") {
          data.calculationService = formattedString;
          UpdateData.calculationService = formattedString;
        } else {
          data.calculationService = null;
          UpdateData.calculationService = null;
        }
        // Call the service function for creating pickup request

        if (item === null) {
          addFranchiseRate(brandId, franchise.id, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.success;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/franchises-rate-list", {
                        state: {
                          item: franchise,
                        },
                      });
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          updateFranchiseRate(brandId, franchise.id, UpdateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.success;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                    setTimeout(() => {
                      navigate("/franchises-rate-list", {
                        state: {
                          item: franchise,
                        },
                      });
                    }, 1500);
                    setIsButtonPressed(false);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                    setIsButtonPressed(false);
                  }
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    } else {
      setIsButtonPressed(false);
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/franchises-rate-list", {
                      state: {
                        item: franchise,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Franchise's Rate {item?.id ? "Edit" : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="code"
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                setCodeError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {codeError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {codeError}
              </p>
            )}

            <label htmlFor="code" className="text-lg" style={{ color: "blue" }}>
              Code <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="description"
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                setDescriptionError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {descriptionError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {descriptionError}
              </p>
            )}

            <label
              htmlFor="description"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Description <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <Dropdown
              id="calculationMode"
              value={calculationMode}
              onChange={(e) => handleCalculationModeChange(e.target.value)}
              options={rateCalculationMode}
              optionLabel="name"
              placeholder="Store"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />

            {calculationModeError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {calculationModeError}
              </p>
            )}
            <label
              htmlFor="calculationMode"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Calculation Mode<span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
        <div className=" mt-4 mx-4 flex-1">
          <FloatLabel>
            <Dropdown
              id="rateModeIn"
              value={rateModeIn}
              onChange={(e) => handleRateModeInChange(e.target.value)}
              options={rateModeInList}
              optionLabel="name"
              placeholder="Store"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />
            {rateModeInError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {rateModeInError}
              </p>
            )}
            <label
              htmlFor="rateModeIn"
              className="text-lg"
              style={{ color: "blue" }}
            >
              Rate Mode In <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      {calculationMode !== "SERVICE" && (
        <div className="flex flex-1 mb-3">
          <div className=" mt-4 mx-4 flex-1">
            <FloatLabel>
              <InputText
                id="rate"
                value={rate}
                onChange={(e) => {
                  setRate(e.target.value);
                  setRateError("");
                }}
                className="w-full text-xl p-2 border-round-xl shadow-2"
                style={{
                  backgroundColor: "#fff",
                }}
              />
              {rateError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {rateError}
                </p>
              )}

              <label
                htmlFor="rate"
                className="text-lg"
                style={{ color: "blue" }}
              >
                Rate <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
        </div>
      )}

      {calculationMode === "SERVICE" && (
        <div className="flex flex-1 mb-3">
          <div className=" mt-4 mx-4 flex-1">
            <FloatLabel>
              <MultiSelect
                id="appService"
                value={appServiceValue}
                onChange={(e) => handleAppServiceChange(e.value)}
                options={appServicesList}
                optionLabel="name"
                optionValue="value"
                placeholder="Select Services"
                className="w-full border-round-xl text-xl shadow-2"
                filter
                valueTemplate={selectedTemplate}
                itemTemplate={optionTemplate}
              />

              {calculationModeServiceError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {calculationModeServiceError}
                </p>
              )}
              <label
                htmlFor="appService"
                className="text-lg"
                style={{ color: "blue" }}
              >
                AppService <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
        </div>
      )}

      {calculationMode === "SERVICE" &&
        appServiceValue &&
        appServiceValue.length > 0 && (
          <div className="mx-4 mt-2">
            <p
              className="text-lg font-semibold mb-2"
              style={{ color: "#1752AA" }}
            >
              Set Rates for Each Service:
            </p>
            {appServiceValue.map((serviceKey) => (
              <div key={serviceKey} className="mb-3">
                <label
                  className="text-md font-medium"
                  style={{ color: "blue" }}
                >
                  {serviceKey} Rate:
                </label>
                <InputText
                  value={serviceRates[serviceKey] || ""}
                  onChange={(e) => {
                    setServiceRates((prev) => ({
                      ...prev,
                      [serviceKey]: e.target.value,
                    }));

                    // Clear individual error on change
                    setServiceRateErrors((prevErrors) => ({
                      ...prevErrors,
                      [serviceKey]: "",
                    }));
                  }}
                  className="w-full text-lg p-2 border-round shadow-2 mt-1"
                />
                {serviceRateErrors[serviceKey] && (
                  <p className="text-sm mt-1" style={{ color: "red" }}>
                    {serviceRateErrors[serviceKey]}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}

      {item !== null && (
        <div className="flex flex-1 mb-3">
          <div className=" mt-4 mx-4 flex-1">
            <FloatLabel>
              <Dropdown
                id="status"
                value={storeStatus}
                onChange={(e) => handleStatusChange(e.target.value)}
                options={StatusList}
                optionLabel="name"
                placeholder="status"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              {statusError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {statusError}
                </p>
              )}
              <label
                htmlFor="status"
                className="text-md"
                style={{ color: "blue" }}
              >
                Status <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
        </div>
      )}

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default FranchisesRateCreate;
